import React from "react";

import { FormControl, Grid, InputLabel, Stack, Typography } from "@mui/material";
import SecondaryButton from "src/components/wallets/Modal/deposit/SecondaryButton";
import SecondaryInputField from "src/components/wallets/Modal/deposit/SecondaryInputField";

interface NonFbDepositCryptoProps {
  showDepositAddresses: boolean;
  exampleTransactionID: string;
  onSubmit: (event: any, txId: string, amount: string) => Promise<void>;
}

const NonFbDepositCryptoModal = (props: NonFbDepositCryptoProps): JSX.Element => {
  const { showDepositAddresses, exampleTransactionID, onSubmit } = props;

  // ================= Component variables =================
  const [txId, setTxId] = React.useState<string>("");
  const [amount, setAmount] = React.useState<string>("");
  const [isError, setisError] = React.useState<boolean>(false);
  const isDisabled = txId.length === 0 || amount.length === 0 || isError;

  // ================= Handlers =================
  const handleTransactionId = (event: any): void => setTxId(event.target.value);

  const handleAmount = (event: any): void => setAmount(event.target.value);

  const handleSubmit = async (event: any): Promise<void> => {
    onSubmit(event, txId, amount);
  };

  React.useEffect(() => {
    if (txId === exampleTransactionID) {
      setisError(true);
    } else {
      setisError(false);
    }
  }, [txId]);

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: "12px" }}>
      <Stack spacing={2}>
        {/* TRANSACTION ID EXMAPLE */}
        <FormControl variant="standard">
          <InputLabel shrink htmlFor="example-transaction-id-input">
            Example Transaction ID
          </InputLabel>
          <SecondaryInputField
            id="deposit-example-transactionID-input"
            value={""}
            onChange={() => {}}
            disabled={true}
            inputType="text"
            placeholder={exampleTransactionID}
            sx={{ backgroundColor: "#F8F9F9" }}
          />
        </FormControl>

        {/* TRANSACTION ID INPUT FIELD */}
        <FormControl variant="standard">
          <InputLabel shrink htmlFor="transaction-id-input">
            Transaction ID
          </InputLabel>
          <SecondaryInputField
            id="deposit-transactionID-input"
            value={txId}
            onChange={handleTransactionId}
            disabled={!showDepositAddresses}
            inputType="text"
            placeholder="Please enter the Deposit Transaction ID"
            sx={{
              border: "1px solid #ced4da",
              backgroundColor: "#fff",
            }}
          />
          {isError && (
            <Grid item xs>
              <Typography variant="caption" color="error">
                Transaction ID cannot be the same as the example transaction ID
              </Typography>
            </Grid>
          )}
        </FormControl>

        {/* AMOUNT INPUT FIELD */}
        <FormControl variant="standard">
          <InputLabel shrink htmlFor="amout-input">
            Amount
          </InputLabel>
          <SecondaryInputField
            value={amount}
            onChange={handleAmount}
            disabled={!showDepositAddresses}
            inputType="number"
            placeholder="Enter the unit amount deposited"
            id="deposit-amount-input"
            sx={{
              border: "1px solid #ced4da",
              backgroundColor: "#fff",
            }}
          />
        </FormControl>

        {/* SUBMIT BUTTON */}
        <SecondaryButton type="submit" disabled={isDisabled}>
          Submit
        </SecondaryButton>
      </Stack>
    </form>
  );
};

export default NonFbDepositCryptoModal;
